import React, { useState, useEffect } from 'react';
import { CheckCircle, XCircle, FileSearch, Download } from 'lucide-react';
import api from '../services/api';

const KYCManagement = () => {
  const [pendingUsers, setPendingUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchPending = async () => {
    try {
      const res = await api.get('/auth/kyc-pending');
      setPendingUsers(res.data.pendingUsers || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPending();
  }, []);

  const handleReview = async (id, status) => {
    if (!window.confirm(`Are you sure you want to ${status} this KYC document?`)) return;
    try {
      await api.put(`/auth/kyc-review/${id}`, { status });
      fetchPending();
    } catch (err) {
      alert('Error updating KYC status');
    }
  };

  const getFullImageUrl = (path) => {
    if (!path) return '';
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    return path.startsWith('http') ? path : `${api.defaults.baseURL}/${cleanPath}`;
  };

  return (
    <div className="dashboard-page">
      <div className="dashboard-header" style={{ marginBottom: '2rem' }}>
        <div>
          <h1>KYC & AML Verification</h1>
          <p>Review pending user identity documents.</p>
        </div>
        <div className="stat-card-new" style={{ padding: '0.8rem 1.5rem', background: 'rgba(252, 213, 53, 0.1)', border: '1px solid rgba(252, 213, 53, 0.3)' }}>
          <h3 style={{ margin: 0, fontSize: '0.8rem', color: '#FCD535', textTransform: 'uppercase' }}>Pending Reviews</h3>
          <p style={{ margin: 0, fontSize: '1.5rem', fontWeight: '800', color: 'white' }}>{pendingUsers.length}</p>
        </div>
      </div>

      <div className="plans-grid">
        {loading ? (
          <div className="spinner" style={{ margin: '2rem auto' }}></div>
        ) : pendingUsers.length === 0 ? (
          <div className="dashboard-panel" style={{ width: '100%', textAlign: 'center', padding: '4rem 2rem' }}>
            <FileSearch size={48} style={{ color: 'var(--text-secondary)', marginBottom: '1rem' }} />
            <h3 style={{ color: 'var(--text-primary)' }}>No Pending Documents</h3>
            <p style={{ color: 'var(--text-secondary)' }}>All users have been verified.</p>
          </div>
        ) : (
          pendingUsers.map(user => (
            <div key={user._id} className="dashboard-panel" style={{ display: 'flex', flexDirection: 'column' }}>
              <div className="panel-header" style={{ marginBottom: '1rem' }}>
                <div>
                  <h3 style={{ margin: '0 0 0.25rem 0', color: 'var(--text-primary)', fontSize: '1.1rem' }}>{user.firstName} {user.lastName}</h3>
                  <p style={{ margin: 0, color: 'var(--text-secondary)', fontSize: '0.85rem' }}>{user.email} • {user.country}</p>
                </div>
                <span className="status-badge pending">Pending</span>
              </div>
              
              <div style={{ flex: 1, background: '#0f172a', borderRadius: '8px', padding: '0.5rem', marginBottom: '1.5rem', minHeight: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid var(--border-color)' }}>
                {user.kycDocument ? (
                  <img src={getFullImageUrl(user.kycDocument)} alt="KYC Document" style={{ maxWidth: '100%', maxHeight: '250px', objectFit: 'contain', borderRadius: '4px' }} />
                ) : (
                  <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem' }}>No document found</p>
                )}
              </div>

              <div style={{ display: 'flex', gap: '1rem' }}>
                <a href={getFullImageUrl(user.kycDocument)} target="_blank" rel="noreferrer" className="btn" style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', background: 'var(--bg-primary)', color: 'var(--text-primary)', textDecoration: 'none' }}>
                  <Download size={16} /> View Full
                </a>
                <button className="btn" style={{ flex: 1, background: 'rgba(239, 68, 68, 0.1)', color: '#ef4444', border: '1px solid rgba(239, 68, 68, 0.2)' }} onClick={() => handleReview(user._id, 'rejected')}>
                  Reject
                </button>
                <button className="btn" style={{ flex: 1, background: 'rgba(16, 185, 129, 0.1)', color: '#10b981', border: '1px solid rgba(16, 185, 129, 0.2)' }} onClick={() => handleReview(user._id, 'approved')}>
                  Approve
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default KYCManagement;
